import React from 'react'

import { faPencilAlt, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./table.module.scss";

interface Props {
    data: any,
    putArticle: any,
    removeArticle: any
}

export const ArticleTable: React.FC<Props> = ({ data, putArticle, removeArticle }) => {

    function changeArticleData(artigo: any) {
        putArticle(artigo)
    }

    return (
        <div className={styles.tableContainer}>
            <table className={styles.table}>
                <thead className={styles.thead}>
                    <tr className={styles.tr1}>
                        <th>Título</th>
                        <th>Descrição</th>
                        <th>Caminho</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody className={styles.tbody}>
                    {
                        data.map((artigo: {
                            ID: number,
                            CM_AUTOR: string,
                            CM_TITULO: string,
                            CM_DESCRICAO: string,
                            CM_CONTEUDO: any,
                            caminho: string
                        }) => {
                            return (
                                <tr key={artigo.ID} className={styles.tr}>
                                    <td width="35%">{artigo.CM_TITULO}</td>
                                    <td width="32.5%">{artigo.CM_DESCRICAO.substring(0, 25)}...</td>
                                    <td width="27.5%">{artigo.caminho}</td>
                                    <td width="5%">
                                        <div className={styles.actionContainer}>
                                            <button className={styles.pencilBox} onClick={() => changeArticleData(artigo)}>
                                                <FontAwesomeIcon icon={faPencilAlt} className="" />
                                            </button>
                                            <button className={styles.trashBox} onClick={() => removeArticle(artigo)}>
                                                <FontAwesomeIcon icon={faTrashAlt} className="" />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            )
                        }
                        )
                    }
                </tbody>
            </table>
        </div>
    )
}